import { IFilter } from '@/components/organisms/FilteredProjectsGallery/FilteredProjectsGallery.types';
import { IGetProjectsParams } from '@/directus/services/common/projects/types';
import { useFiltersStore } from '@/store/useFiltersStore';
import { usePageStore } from '@/store/usePageStore';
import { TLangIso } from '@/types/global';

const getFilterIdsByCollection = (
  items: IFilter[],
  collectionName: string,
  visibility: 'public' | 'private'
): string[] => {
  return items
    .filter(
      (item) =>
        item.collection === collectionName && item.visibility === visibility
    )
    .map((item) => item.id);
};

export const getProjectFetchParamsFromFilters = ({
  filters,
  searchText,
  isUserLogged,
  langIso
}: {
  filters: IFilter[];
  searchText?: string;
  isUserLogged?: boolean;
  langIso: TLangIso;
}): IGetProjectsParams => {
  if (filters.length > 0 || searchText) {

    const servicesIDs = getFilterIdsByCollection(filters, 'services', 'public');
    const subservicesIDs = getFilterIdsByCollection(
        filters,
        'subservices',
        'public'
      );
    const typologiesIDs = getFilterIdsByCollection(
        filters,
        'typologies',
        'public'
      );
    const typologiesSimplifiedIDs = getFilterIdsByCollection(
        filters,
        'typologies_simplified',
        'public'
      );
    const yearsIDs = getFilterIdsByCollection(filters, 'years', 'public');
    const locationsLevel1IDs = getFilterIdsByCollection(
        filters,
        'locations_level_1',
        'public'
      );
    const locationsLevel2IDs = isUserLogged
      ? getFilterIdsByCollection(filters, 'locations_level_2', 'private')
      : [];   

    return {
      ...searchText && { search: searchText },
      ...servicesIDs.length > 0 && { servicesIDs },
      ...subservicesIDs.length > 0 && { subservicesIDs },
      ...typologiesIDs.length > 0 && { typologiesIDs },
      ...typologiesSimplifiedIDs.length > 0 && { typologiesSimplifiedIDs },
      ...yearsIDs.length > 0 && { yearsIDs },
      ...locationsLevel1IDs.length > 0 && { locationsLevel1IDs },
      ...(locationsLevel2IDs.length > 0 && isUserLogged) && { locationsLevel2IDs },
      lang: langIso,
    };
  }

  return {
    lang: 'en-US'
  };
};


export const computeParamsFetch = (pageFilters: IFilter[] = []) => {
  const isUserLogged = usePageStore.getState().isUserLogged;
  const langIso = usePageStore.getState().langIso;
  const selectedFilters = useFiltersStore.getState().selectedFilters;
  const search = useFiltersStore.getState().search;
  const selected = selectedFilters ?? {};
  const filters = [ ...(selected.filters || []), ...pageFilters ];
  return (filters && filters.length > 0) || search?.value
    ? getProjectFetchParamsFromFilters({
        filters,
        searchText: search?.value || '',
        isUserLogged,
        langIso,
      })
    : { lang: langIso };
}